import { pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

export const linkCarouselWrapper = css`
  margin-top: ${pxToRem(16)};
  padding: ${pxToRem(16)} 0;
  border-bottom: ${pxToRem(1)} solid var(--neutral-black-30);
  border-top: ${pxToRem(1)} solid var(--neutral-black-30);
`;
